import { Ajax } from '@shared/Ajax';
import { saveAs } from 'file-saver';
import { Drawing } from '@pages/mass/js-dxf/Drawing';


export const MassDxfExport = {
    export: (gridId: number, name: string = 'generated') => {

        Ajax({
            url: '/api/1/mass/grid/cells.json',
            data: {
                gridId
            }
        }).done(resp => {
            const cells = resp.cells.map(c => [
                [c.p1.e, c.p1.n],
                [c.p2.e, c.p2.n],
                [c.p3.e, c.p3.n],
                [c.p4.e, c.p4.n],
                [c.p1.e, c.p1.n]
            ]);

            const dxf = new Drawing();
            cells.forEach(cell => dxf.drawPolyline(cell));
            const file = new Blob([dxf.toDxfString()], { type: 'text/plain;charset=utf-8' });
            saveAs(file, name + '.dxf');
        });
    }
};
